import { createContext, useContext, useState } from 'react';

type TypebotIdContextType = {
  typebotId: string | null;
  setTypebotId: (id: string | null) => void;
};

const TypebotIdContext = createContext<TypebotIdContextType>({
  typebotId: null,
  setTypebotId: () => {},
});

export const useTypebotId = () => useContext(TypebotIdContext);

export function TypebotIdProvider({ children }: { children: React.ReactNode }) {
  const [typebotId, setTypebotId] = useState<string | null>(null);

  return (
    <TypebotIdContext.Provider value={{ typebotId, setTypebotId }}>
      {children}
    </TypebotIdContext.Provider>
  );
}